var exports = {
  "iE": "xaf9ae18d--6d47ad--wrapper",
  "Zu": "xaf9ae18d--6d47ad--fixed",
  "qb": "xaf9ae18d--6d47ad--normal",
  "x6": "xaf9ae18d--6d47ad--button",
};

module.exports = exports;
